import React from "react";

export default function StepContainer({ children, className = "" }) {
  return (
    <div className={`flex flex-col gap-[26px] ${className}`}>{children}</div>
  );
}
